import { GraphQLScalarType, Kind } from 'graphql'

const isValidDate = (date: Date) => {
  return !isNaN(date.getTime())
}

function parseDate(value) {
  const result = new Date(value)
  if (!isValidDate(result)) {
    throw new Error(`Invalid date: ${value}`)
  }
  if (value !== result.toJSON()) {
    throw new Error(
      `Invalid date format, only accepts: YYYY-MM-DDTHH:MM:SS.SSSZ: ${value}`
    )
  }
  return result
}

export type DateTime = string

export const dateTimeType = new GraphQLScalarType({
  name: 'DateTime',
  description: 'DateTime type serialized as ISO-8601 string',
  serialize(value) {
    const date = new Date(value)

    if (isNaN(date.getTime())) {
      throw new Error('Value is an invalid Date')
    }
    return date.toJSON()
  },
  parseValue(value) {
    if (typeof value !== 'string') {
      throw new Error('Value is not an instance of string')
    }
    return parseDate(value)
  },
  parseLiteral(ast) {
    if (ast.kind !== Kind.STRING) {
      throw new Error(
        `Can only parse strings to dates but got a: ${ast.kind}, ${[ast]}`
      )
    }
    try {
      return parseDate(ast.value)
    } catch (e) {
      throw new Error(`Query error: ${e.message}, ${[ast]}`)
    }
  }
})
